import { render, staticRenderFns } from "./SingleBlock.vue?vue&type=template&id=487c279d&scoped=true&"
import script from "./SingleBlock.vue?vue&type=script&lang=js&"
export * from "./SingleBlock.vue?vue&type=script&lang=js&"
import style0 from "./SingleBlock.vue?vue&type=style&index=0&id=487c279d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487c279d",
  null
  
)

export default component.exports